import { render, staticRenderFns } from "./FormOtherEnderecos.vue?vue&type=template&id=9f6711fe"
import script from "./FormOtherEnderecos.vue?vue&type=script&lang=js"
export * from "./FormOtherEnderecos.vue?vue&type=script&lang=js"
import style0 from "./FormOtherEnderecos.vue?vue&type=style&index=0&id=9f6711fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports